(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["haarfen-from-studio"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('haarfen-reveal-section')) {
    class HaarfenRevealSection extends HTMLElement {
      connectedCallback() {
        this.reveal();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      reveal() {
        this.observer?.disconnect();

        const animation = this.dataset.animation || 'none';
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const designMode = Boolean(window.Shopify && window.Shopify.designMode);

        if (designMode || animation === 'none' || reduceMotion || !('IntersectionObserver' in window)) {
          this.removeAttribute('data-reveal-ready');
          this.classList.add('is-visible');
          return;
        }

        this.setAttribute('data-reveal-ready', 'true');
        this.classList.remove('is-visible');

        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries[0]?.isIntersecting) return;
            this.classList.add('is-visible');
            this.observer?.disconnect();
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
        );

        this.observer.observe(this);
      }
    }

    customElements.define('haarfen-reveal-section', HaarfenRevealSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haarfen-material-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const tagName = 'haarfen-material-banner-section';
    if (!customElements.get(tagName)) {
      class HaarfenMaterialBannerSection extends HTMLElement {
        connectedCallback() { this.setupReveal(); }
        disconnectedCallback() { this.cleanupReveal(); }
        cleanupReveal() {
          this.observer?.disconnect(); this.observer = null;
          clearTimeout(this.revealFallbackTimer); clearTimeout(this.revealCleanupTimer);
        }
        isThemeEditor() {
          return Boolean((window.Shopify && window.Shopify.designMode) || document.documentElement.classList.contains('shopify-design-mode') || document.body.classList.contains('shopify-design-mode') || this.closest('[data-shopify-editor-section]'));
        }
        showImmediately() { this.cleanupReveal(); this.classList.add('is-visible'); this.removeAttribute('data-reveal-ready'); }
        reveal() {
          this.classList.add('is-visible');
          const duration = parseInt(getComputedStyle(this).getPropertyValue('--hf-mb-animation-duration'),10) || 850;
          clearTimeout(this.revealFallbackTimer); clearTimeout(this.revealCleanupTimer);
          this.revealCleanupTimer=setTimeout(()=>this.removeAttribute('data-reveal-ready'),duration+180);
          this.observer?.disconnect(); this.observer=null;
        }
        setupReveal() {
          this.cleanupReveal();
          const animation=this.dataset.animation || 'none';
          const reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (this.isThemeEditor() || animation==='none' || reduceMotion || !('IntersectionObserver' in window)) { this.showImmediately(); return; }
          this.classList.remove('is-visible'); this.setAttribute('data-reveal-ready','true');
          this.revealFallbackTimer=setTimeout(()=>this.reveal(),1400);
          const rect=this.getBoundingClientRect(); const vh=window.innerHeight || document.documentElement.clientHeight;
          if (rect.top < vh*0.96 && rect.bottom > 0) { requestAnimationFrame(()=>this.reveal()); return; }
          this.observer=new IntersectionObserver(entries=>{ if(entries.some(e=>e.isIntersecting)) this.reveal(); },{rootMargin:'0px 0px -6% 0px',threshold:0.06});
          this.observer.observe(this);
        }
      }
      customElements.define(tagName,HaarfenMaterialBannerSection);
    }
    const revealEditorSection=(event)=>event.target?.querySelectorAll?.(tagName).forEach(section=>section.showImmediately?.());
    document.addEventListener('shopify:section:load',revealEditorSection);
    document.addEventListener('shopify:section:select',revealEditorSection);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haarfen-material-studies"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('haarfen-reveal-section')) {
    class HaarfenRevealSection extends HTMLElement {
      connectedCallback() {
        this.reveal = this.reveal.bind(this);

        if (window.Shopify && Shopify.designMode) {
          this.reveal();
          return;
        }

        if (this.dataset.animation === 'none' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.reveal();
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.reveal();
                this.observer.disconnect();
              }
            });
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
        );

        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      reveal() {
        requestAnimationFrame(() => this.classList.add('is-visible'));
      }
    }

    customElements.define('haarfen-reveal-section', HaarfenRevealSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haarfen-studio-teaser"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const tagName = 'haarfen-studio-teaser-section';

    if (!customElements.get(tagName)) {
      class HaarfenStudioTeaserSection extends HTMLElement {
        connectedCallback() {
          this.setupReveal();
        }

        disconnectedCallback() {
          this.cleanupReveal();
        }

        cleanupReveal() {
          this.observer?.disconnect();
          this.observer = null;
          window.clearTimeout(this.revealFallbackTimer);
          window.clearTimeout(this.revealCleanupTimer);
        }

        isThemeEditor() {
          return Boolean(
            (window.Shopify && window.Shopify.designMode) ||
            document.documentElement.classList.contains('shopify-design-mode') ||
            document.body.classList.contains('shopify-design-mode') ||
            this.closest('[data-shopify-editor-section]')
          );
        }

        showImmediately() {
          this.cleanupReveal();
          this.classList.add('is-visible');
          this.removeAttribute('data-reveal-ready');
        }

        reveal() {
          this.classList.add('is-visible');
          const duration = Number.parseInt(
            getComputedStyle(this).getPropertyValue('--hf-st-animation-duration'),
            10
          ) || 850;

          window.clearTimeout(this.revealFallbackTimer);
          window.clearTimeout(this.revealCleanupTimer);
          this.revealCleanupTimer = window.setTimeout(() => {
            this.removeAttribute('data-reveal-ready');
          }, duration + 180);
          this.observer?.disconnect();
          this.observer = null;
        }

        setupReveal() {
          this.cleanupReveal();

          const animation = this.dataset.animation || 'none';
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          /* The section is visible by default. It is only prepared for animation
             after this script has initialised successfully. */
          if (
            this.isThemeEditor() ||
            animation === 'none' ||
            reduceMotion ||
            !('IntersectionObserver' in window)
          ) {
            this.showImmediately();
            return;
          }

          this.classList.remove('is-visible');
          this.setAttribute('data-reveal-ready', 'true');

          /* Never allow a failed observer or browser quirk to leave content hidden. */
          this.revealFallbackTimer = window.setTimeout(() => this.reveal(), 1400);

          const rect = this.getBoundingClientRect();
          const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
          if (rect.top < viewportHeight * 0.96 && rect.bottom > 0) {
            requestAnimationFrame(() => this.reveal());
            return;
          }

          this.observer = new IntersectionObserver(
            (entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;
              this.reveal();
            },
            { rootMargin: '0px 0px -6% 0px', threshold: 0.06 }
          );

          this.observer.observe(this);
        }
      }

      customElements.define(tagName, HaarfenStudioTeaserSection);
    }

    const revealEditorSection = (event) => {
      event.target
        ?.querySelectorAll?.(tagName)
        .forEach((section) => section.showImmediately?.());
    };

    document.addEventListener('shopify:section:load', revealEditorSection);
    document.addEventListener('shopify:section:select', revealEditorSection);
    document.addEventListener('shopify:block:select', revealEditorSection);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-layout-library"]) return;
  try {
    
if (!customElements.get('haarfen-layout-library')) {
  customElements.define('haarfen-layout-library', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.querySelector('nav').addEventListener('click', event => {
        const link = event.target.closest('a[href^="#"]');
        if (!link) return;
        const target = this.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-styling-edit"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('haarfen-look-slider')) {
  customElements.define('haarfen-look-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.cards = [...this.querySelectorAll('[data-look-card]')];
      this.current = 0;
      if (!this.cards.length) return;
      this.setAttribute('data-enhanced', '');
      this.querySelector('[data-look-controls]').hidden = this.cards.length < 2;
      this.querySelector('[data-look-next]').addEventListener('click', () => this.move(1));
      this.querySelector('[data-look-prev]').addEventListener('click', () => this.move(-1));
      this.querySelector('[data-look-track]').addEventListener('touchstart', e => { this.startX = e.changedTouches[0].clientX; this.startY = e.changedTouches[0].clientY; }, { passive: true });
      this.querySelector('[data-look-track]').addEventListener('touchend', e => {
        const dx = e.changedTouches[0].clientX - this.startX;
        const dy = e.changedTouches[0].clientY - this.startY;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) this.move(dx < 0 ? 1 : -1);
      }, { passive: true });
      this.update();
    }
    move(step) { this.current = (this.current + step + this.cards.length) % this.cards.length; this.update(); }
    update() {
      const secondary = this.cards.length > 1 ? (this.current + 1) % this.cards.length : -1;
      this.cards.forEach((card, i) => {
        card.hidden = i !== this.current && i !== secondary;
        card.classList.toggle('hf-look__card--lead', i === this.current);
        card.classList.toggle('hf-look__card--secondary', i === secondary);
        card.style.order = i === this.current ? '0' : '1';
      });
      this.querySelector('[data-look-count]').textContent = String(this.current + 1).padStart(2, '0') + ' / ' + String(this.cards.length).padStart(2, '0');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
